import React, { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import PageHeader, { Card } from "@/components/PageHeader";

const ACTION_COLOR = {
  create: "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300",
  update: "bg-blue-100 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300",
  delete: "bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-300",
  upload: "bg-purple-100 text-purple-700 dark:bg-purple-500/10 dark:text-purple-300",
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)); }, []);

  return (
    <div data-testid="audit-page">
      <PageHeader overline="Security" title="Audit Log" description="Every change tracked for accountability." />
      <Card className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-secondary text-xs uppercase tracking-wider text-muted-foreground">
            <tr>{["When", "User", "Role", "Action", "Entity", "Details"].map((h) => <th key={h} className="text-left px-4 py-3">{h}</th>)}</tr>
          </thead>
          <tbody>
            {logs.length === 0 && <tr><td colSpan={6} className="p-10 text-center text-muted-foreground">No activity yet.</td></tr>}
            {logs.map((l) => (
              <tr key={l.id} className="border-t border-border hover:bg-secondary/40">
                <td className="px-4 py-3 text-muted-foreground">{fmtDate(l.created_at)}</td>
                <td className="px-4 py-3">{l.user_email}</td>
                <td className="px-4 py-3 capitalize">{l.user_role}</td>
                <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded-full text-xs font-semibold capitalize ${ACTION_COLOR[l.action] || "bg-secondary"}`}>{l.action}</span></td>
                <td className="px-4 py-3 capitalize">{l.entity}</td>
                <td className="px-4 py-3 text-xs text-muted-foreground font-mono">{Object.keys(l.details || {}).length ? JSON.stringify(l.details) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
